import { Typography } from '@mui/material';
import { styled } from '@mui/system';

export const FairnessWrapper = styled('div')(({ theme }) => ({
  maxWidth: '960px',
  margin: '0 auto',
  paddingTop: theme.spacing(3),
  fontFamily: 'Readex Pro',
}));
export const FairnessBanner = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',

  '& img': {
    width: '326px',
    marginRight: theme.spacing(3),
  },
  [theme.breakpoints.down('md')]: {
    '& img': {
      width: '100%',
      marginRight: 0,
      marginBottom: theme.spacing(2),
    },
    '& .MuiBox-root': {
      width: '100%',
    },
  },
}));

export const SectionWrapper = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(6),
}));
export const SectionTitle = styled(Typography)(({ theme }) => ({
  fontSize: '24px',
  marginBottom: theme.spacing(3),
}));
export const SectionParagraph = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  color: '#B1B6C6',
  marginBottom: theme.spacing(2),
  wordBreak: 'break-all',
}));

export const CodeWrapper = styled('pre')(({ theme }) => ({
  backgroundColor: '#E3E6EC',
  color: '#141722',
  padding: theme.spacing(2),
  borderRadius: '6px',
  overflowX: 'auto',
  whiteSpace: 'pre-wrap',
}));

export const GlobalSeedWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
}));
export const GlobalSeedContent = styled('div')(({ theme }) => ({
  display: 'flex',
  padding: theme.spacing(2),
  marginLeft: theme.spacing(3),
  alignItems: 'center',
  justifyContent: 'space-between',
  border: '1px solid #303545',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.grey[1000],
  flex: 1,
  height: '48px',
  [theme.breakpoints.down('md')]: {
    '&>span': {
      width: '120px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  },
}));
